import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tick",
  "use": "icon-tick-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 15\" id=\"icon-tick\">\n    <polygon points=\"6.3,9.5 12.7,0 16,2.2 7.4,15 0,10.1 2.2,6.8 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/tick.svg
// module id = 179
// module chunks = 0 1 2